import { useLanguage } from "@/i18n";

export default function Marquee() {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <div data-testid="editorial-marquee" className="bg-sand border-y border-border/50 py-6 overflow-hidden select-none">
      <div className="animate-vb-marquee flex whitespace-nowrap gap-24 w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex gap-24">
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-24">
                <span className="font-serif italic text-2xl lg:text-3xl text-ink/80">{item}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-[#C9A227] inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
